import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import withFormGroup from "../../../../modules/commons/withFormGroup";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import { flattenFormGroupObject, mapToObjectDDL } from "../../../common/mapper";
import { fetchDataAsync } from "../../../../Services/Utils";
import Api from "../../../../Services/Api";
import { HttpStatus } from "../../../common/Constants";
import { shortUuid } from "../utils";

class MasterSopirDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usernameData: [],
      driverOptions: [],
      cabangOptions: [],
      originData: null,
      lastState: null,
    };
  }

  componentDidMount() {
    const { selectedData } = this.props;
    this.fetchData(selectedData?.driverId);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.lastState !== this.state.lastState && this.state.lastState) {
      this.fetchSpecialDDL(
        this.state.lastState,
        prevState.lastState,
        prevProps.controls
      );
    }
  }

  fetchData = async (driverId) => {
    this.props.handleTriggerLoading();
    if (driverId) {
      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getDetailSopirByDriverId,
        menuName: "Master Sopir - Detail Sopir",
        setError: this.props.setError,
        args: { driverId },
      });
      if (res?.ok && res.data?.status === HttpStatus.SUCCESS) {
        this.populateDataDetail(res.data.data);
      }
    } else {
      this.props.setValue("driverId", shortUuid());
    }
    this.props.handleTriggerLoading();
  };

  fetchDataCabang = async (id) => {
    this.props.handleTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getCabangByIdUser,
      menuName: "Master Sopir",
      setError: this.props.setError,
      args: id,
    });
    if (res?.ok && res.data?.status === HttpStatus.SUCCESS) {
      this.setState({
        cabangOptions: res.data.data
      });
    }
    this.props.handleTriggerLoading();
  };

  fetchSpecialDDL = async (field, prevField, prevControls) => {
    console.log(field, prevField);
    if (field === "driverUsername") {
      this.fetchDriverUsernameWithComparasion();
    }
    if (field === "driverUsernameSelected") {
      this.fetchAutoFillDriverName();
    }
    if (field === "driverNameSelected") {
      this.fetchAutoFillUsername();
    }
    if (field === "driverName") {
      this.fetchDriverName();
    }
  };

  fetchDriverUsernameWithComparasion = async () => {
    this.props.handleTriggerLoading();
    const promises = await Promise.all([
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_AUTH").getAllUserForMasterDriver,
        menuName: "Master Sopir",
        setError: this.props.setError,
        args: null,
      }),
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllIdUserDriver,
        menuName: "Master Sopir",
        setError: this.props.setError,
        args: null,
      }),
    ]);
    const [allUser, allUserIsDriver] = promises;
    if (
      allUser.ok &&
      allUserIsDriver.ok &&
      allUser.data.status === HttpStatus.SUCCESS &&
      allUserIsDriver.data.status === HttpStatus.SUCCESS
    ) {
      const allUserData = allUser.data.data;
      const allUserIsDriverData = allUserIsDriver.data.data;
      const usernameDDL = allUserData.filter(
        (item) => !allUserIsDriverData.includes(item.id)
      );
      this.setState({
        usernameData: usernameDDL,
      });
    }
    this.props.handleTriggerLoading();
  };

  fetchAutoFillDriverName = async () => {
    this.props.handleTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").findEmployeeByUserId,
      menuName: "Master Sopir",
      setError: this.props.setError,
      args: this.props.controls.driverUsername?.value?.id,
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState({ driverOptions: [res?.data?.data] });
      this.handleChange("driverName", {
        label: res?.data?.data?.name,
        value: res?.data?.data?.iduser,
        employeeId: res?.data?.data.employeeId,
      });
      this.fetchDataCabang(res?.data?.data?.iduser);
    }
    this.props.handleTriggerLoading();
  };

  fetchDriverName = async () => {
    this.props.handleTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getEmployeeForDriver,
      menuName: "Master Sopir",
      setError: this.props.setError,
      args: {},
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState({ driverOptions: res.data.data });
    }
    this.props.handleTriggerLoading();
  };

  fetchAutoFillUsername = async (id) => {
    this.props.handleTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_AUTH").getMasterUserById,
      menuName: "Master Sopir",
      setError: this.props.setError,
      args: this.props.controls.driverName.value?.value,
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState({
        usernameData: [res.data.data],
      });
      this.handleChange("driverUsername", {
        label: res.data.data?.username,
        value: res.data.data?.username,
        id: res.data.data?.id || null,
      });
      this.fetchDataCabang(res?.data?.data?.id);
    }
    this.props.handleTriggerLoading();
  };

  populateDataDetail = async (value) => {
    const {
      driverId,
      driverName,
      driverUsername,
      driverCabang,
      employeeId,
      userId,
    } = value;
    this.setState({ originData: value });
    this.handleChange("driverId", driverId);
    this.handleChange("driverName", {
      label: driverName,
      value: userId,
      employeeId: employeeId,
    });
    this.handleChange(
      "driverUsername",
      mapToObjectDDL(driverUsername, driverUsername)
    );
    this.handleChange(
      "driverCabang",
      driverCabang.map((item) => ({
        label: item.namaCabang,
        value: item.kodeCabang,
        refCabangId: item.refCabangId,
      }))
    );
    this.fetchDataCabang(userId);
  };

  handleSubmit = () => {
    const { onSubmit, controls, validate } = this.props;
    const { originData } = this.state;
    onSubmit(flattenFormGroupObject(controls), validate(), originData);
  };

  handleChange = (name, value) => {
    this.props.setValue(name, value);
  };

  transformDriverOptions = (data) => {
    return data.map((item) => ({
      label: item.name,
      value: item.iduser,
      employeeId: item.employeeId,
    }));
  };

  transformDriverCabangOptions = (data) => {
    return data.map((item) => ({
      label: item.namaCabang,
      value: item.kodeCabang,
      refCabangId: item?.refCabangId || null,
    }));
  };

  transformDriverUsernameOptions = (data) => {
    return data.map((item) => ({
      label: item.username,
      value: item.username,
      id: item?.id || null
    }));
  };

  setLastState = (name) => this.setState({ lastState: name });

  render() {
    const { visible, onClickClose, controls, errors } = this.props;
    const { usernameData, driverOptions, cabangOptions, originData } = this.state;
    return (
      <React.Fragment>
        <SimpleModal
          title="Form Detail Master Sopir"
          visible={visible}
          styles={{ width: "50%" }}
          onClickClose={() => onClickClose()}
          content={
            <ModalContainer>
              <FlexView column>
                <SimpleInput
                  label="ID Sopir"
                  mandatory
                  readOnly
                  errorMessage={errors?.driverId}
                  value={controls.driverId.value}
                />
                <SimpleDDL
                  box="search"
                  name="driverUsername"
                  label="Username"
                  mandatory
                  isClearable
                  disabled={originData?.useInExpedisi}
                  errorMessage={errors?.driverUsername}
                  options={this.transformDriverUsernameOptions(usernameData)}
                  onMenuOpen={(res) => {
                    this.setLastState("driverUsername");
                  }}
                  value={controls.driverUsername.value}
                  onChange={(value, { name }) => {
                    this.handleChange(name, value);
                    this.setLastState("driverUsernameSelected");
                  }}
                />
                <SimpleDDL
                  box="search"
                  name="driverName"
                  label="Nama Sopir"
                  mandatory
                  isClearable
                  disabled={originData?.useInExpedisi}
                  errorMessage={errors?.driverName}
                  options={this.transformDriverOptions(driverOptions)}
                  value={controls.driverName.value}
                  onMenuOpen={() => {
                    this.setLastState("driverName");
                  }}
                  onChange={(value, { name }) => {
                    this.handleChange(name, value);
                    this.setLastState("driverNameSelected");
                  }}
                />
                <SimpleDDL
                  box="multiselect"
                  label="Cabang Bertugas"
                  name="driverCabang"
                  mandatory
                  errorMessage={errors?.driverCabang}
                  options={this.transformDriverCabangOptions(cabangOptions)}
                  value={controls.driverCabang.value}
                  onChange={(value, { name }) => this.handleChange(name, value)}
                />
              </FlexView>
              <FlexView style={{ justifyContent: "flex-end" }}>
                <SimpleButton text="Simpan" onClick={this.handleSubmit} />
              </FlexView>
            </ModalContainer>
          }
        />
      </React.Fragment>
    );
  }
}

export default withFormGroup(MasterSopirDetail);
